import HttpService from "./http";

export type LinkFailureStage = "lookup" | "attach";

export interface LinkFailure {
  id: string;
  partner_id: string;
  entity_id: string;
  entity_name: string | null;
  user_id: string | null;
  stage: LinkFailureStage;
  error: string;
  status: "open" | "resolved";
  attempts: number;
  last_attempt_at: string | null;
  last_error: string | null;
  created_at: string;
  resolved_at: string | null;
  resolved_by: string | null;
  resolution: "attached" | "already_attached" | null;
}

export interface LinkFailureReplay {
  resolved: boolean;
  failure: LinkFailure;
}

const base = (customerId: string, entityId: string) =>
  `/${customerId}/${entityId}/partners/link-failures`;

const PartnerLinkFailureService = {
  list: async (customerId: string, entityId: string) =>
    (await HttpService.get(base(customerId, entityId))).data
      .element as LinkFailure[],

  replay: async (customerId: string, entityId: string, failureId: string) =>
    (
      await HttpService.post(
        `${base(customerId, entityId)}/${encodeURIComponent(failureId)}/replay`,
        {}
      )
    ).data.element as LinkFailureReplay,
};

export default PartnerLinkFailureService;
